import { render, staticRenderFns } from "./file-viewer.vue?vue&type=template&id=57fef3aa&scoped=true"
import script from "./file-viewer.vue?vue&type=script&lang=js"
export * from "./file-viewer.vue?vue&type=script&lang=js"
import style0 from "./file-viewer.vue?vue&type=style&index=0&id=57fef3aa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fef3aa",
  null
  
)

export default component.exports